'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Bar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Bar(props) {
  var useBoxShadow = props.useBoxShadow,
      height = props.height,
      color = props.color,
      className = props.className,
      _props$progress = props.progress,
      active = _props$progress.active,
      value = _props$progress.value;


  var barStyles = {
    width: value + '%',
    height: height,
    backgroundColor: color
  };

  if (useBoxShadow) {
    barStyles.boxShadow = '0 0 5px ' + color;
  }

  var wrapperClassNames = (0, _classnames2.default)('reprogressbar', className, {
    'reprogressbar--active': active,
    'reprogressbar--inactive': !active
  });

  return _react2.default.createElement(
    'div',
    { className: wrapperClassNames },
    active && _react2.default.createElement('div', { className: 'reprogressbar_bar', style: barStyles })
  );
}

Bar.propTypes = {
  // color: _react.PropTypes.string,
  // height: _react.PropTypes.string,
  // className: _react.PropTypes.string,
  // useBoxShadow: _react.PropTypes.bool,
  // progress: _react.PropTypes.shape({
  //   active: _react.PropTypes.bool,
  //   value: _react.PropTypes.number
  // })
};

Bar.defaultProps = {
  color: '#29d',
  height: '2px',
  useBoxShadow: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/reprogressbars/lib/components/Bar.js
// module id = 42
// module chunks = 0